<template>
    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow" v-if="dato_cuatrimestre && validacionZona">

            <v-row justify="center">
                <h3 class="text-center">LISTA DE EMPLEADOS </h3><br>
                <h3 class="text-center">CUATRIMESTRE : {{ dato_cuatrimestre.no_cuatrimestre }} DEL AÑO {{ dato_cuatrimestre.anio }}</h3><br>
                <h4 class="text-center">FECHA INICIO EVALUACIÓN : <b>{{ dato_cuatrimestre.fecha_inicio_captura }}</b> - FECHA FIN EVALUACIÓN <b>{{ dato_cuatrimestre.fecha_fin_captura }}</b></h4><br>
                <v-alert class="text-center" v-if="dataFechaExtendida" type="info" icon="mdi-alert-circle-outline">
                        TIENE UNA FECHA EXTENDIDA DE EVALUACIÓN : {{ dataFechaExtendida.fecha_final_captura }}
                </v-alert> <br>
            </v-row>

            <br>

            <v-row v-if="mostrar_tabla_empleado && !existeExcepcionPorcentajeZonaAds">
                <v-col cols="6" sm="6">
                    <v-alert v-if="informacion_evaluacion.puntaje_maximo && id_zona_adscripcion >0" type="error" icon="mdi-alert-circle-outline">
                        SE HA ALCANZADO EL NÚMERO MÁXIMO DE EMPLEADOS REGISTRADOS CON PUNTAJE MÁXIMO!!
                    </v-alert>

                </v-col>
                <v-col cols="6" sm="6">
                    <v-alert v-if="informacion_evaluacion.puntaje_minimo && id_zona_adscripcion >0" type="error" icon="mdi-alert-circle-outline">
                        SE HA ALCANZADO EL NÚMERO MÁXIMO DE EMPLEADOS REGISTRADOS CON PUNTAJE MÍNIMO!!!
                    </v-alert>
                </v-col>
            </v-row>

            <br>

            <v-row v-if="mostrar_tabla_empleado">
                <!--  -->
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <!-- <th style="font-weight: bold;" COLSPAN="4" class="text-center"> <h3>TOTAL INGRESOS {{ anio }}</h3>  </th> -->
                            </tr>
                            <tr>
                                <th class="text-center" style="font-weight: bold;">
                                    <h3>Total a evaluar</h3>
                                </th>
                                <th class="text-center" style="font-weight: bold;">
                                    <h3>Total enviados</h3>
                                </th>
                                <th class="text-center" style="font-weight: bold;">
                                    <h3>Total guardados</h3>
                                </th>

                                <th class="text-center" style="font-weight: bold;">
                                    <h3>Por evaluar</h3>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center" style="font-weight: bold;" >
                                    <h3>{{informacion_evaluacion.total_a_evaluar}}</h3>
                                </td>

                                <td class="text-center" style="font-weight: bold;" >
                                    <h3>{{informacion_evaluacion.total_enviados}}</h3>
                                </td>

                                <td class="text-center" style="font-weight: bold;" >
                                    <h3>{{informacion_evaluacion.total_guardados}}</h3>
                                </td>

                                <td class="text-center" style="font-weight: bold;" >
                                    <h3>{{informacion_evaluacion.restantes}}</h3>
                                </td>

                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <!--  -->
            </v-row>
            <br>
            <!--  -->
            <v-row justify="center" v-if="mostrar_tabla_empleado">
                <v-col class="d-flex" cols="12" sm="4">
                    <label>ESTADO EVALUACIÓN</label><br>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <label>ZONA DE ADSCRIPCIÓN</label><br>
                </v-col>
            </v-row>
            <!--  -->
            <v-row justify="center" v-if="mostrar_tabla_empleado">
                <v-col class="d-flex" cols="12" sm="4">
                    <v-select color="blue-grey lighten-4" solo item-color="blue-grey lighten-4" :menu-props="{ top: true, offsetY: false }" v-model="tipo_filtro" :items="tipos_filtro" item-text="descripcion"
                        item-value="id" label="ESTADO EVALUACIÓN" @change="load_empleados_a_evaluar">
                    </v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select color="blue-grey lighten-4" solo item-color="blue-grey lighten-4" :menu-props="{ top: true, offsetY: false }" v-model="id_zona_adscripcion" :items="zonas_adscripcion" item-text="descripcion"
                        item-value="id_zona_adscripcion" label="ZONA DE ADSCRIPCIÓN" @change="load_empleados_a_evaluar();load_datos_cuatrimestre_evaluacion()">
                    </v-select>
                </v-col>
            </v-row>
            <!--  -->
            <v-row justify="center">
                <v-row v-if="mostrar_tabla_empleado">
                    <v-col v-if="showTable" cols="12" sm="12">
                        <v-client-table :data="empleados_a_evaluar" :columns="columns" :options="options">

                            <!--  -->
                            <template slot="acciones" slot-scope="empleado">
                                <v-menu bottom right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item  @click="cambiar_vista_formulario(empleado.row)">
                                            <v-list-item-icon>
                                                <v-icon class="text-success">mdi-arrow-right-bold-box</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>Evaluar</v-list-item-title>
                                        </v-list-item>

                                        <v-list-item v-if="empleado.row.estado_evaluacion == 'ENVIADO'" @click="descargarAcuse(empleado.row)">
                                            <v-list-item-icon>
                                                <v-icon class="text-success">mdi-file-pdf-box</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title  >Descargar acuse</v-list-item-title>
                                        </v-list-item>


                                    </v-list>
                                </v-menu>
                            </template>
                            <!--  -->
                            <template slot="estado_evaluacion" slot-scope="empleado">
                                <span v-if="empleado.row.estado_evaluacion =='GUARDADO' || empleado.row.estado_evaluacion =='ENVIADO'" class="text-success">
                                    {{ empleado.row.estado_evaluacion }}
                                </span>
                                <span v-else class="text-danger">NO EVALUADO</span>

                            </template>
                        </v-client-table>
                    </v-col>
                    <v-row v-if="showTable" justify="center">
                      <v-col cols="12" sm="12">
                          <span class="text-center" style="color: red; display: block; font-size:24px; padding-bottom: 20px;"><v-icon left class="red--text" large>mdi-alert-circle-outline</v-icon>¡NO OLVIDES DESCARGAR LOS ACUSES!</span>

                      </v-col>
                    </v-row>
                </v-row>
                <div v-else>
                    <v-container>
                        <v-row>
                            <v-col class="text-right" cols="12">
                            <v-btn @click="funcion_regresar();" class="ma-2" color="primary">Regresar</v-btn>
                            </v-col>
                        </v-row>
                        <v-form>
                            <u >
                                <FONT SIZE=5 style="text-align: center;">CÉDULA DE EVALUACIÓN DEL DESEMPEÑO LABORAL</FONT>
                            </u>
                            <br>
                            <!--  -->
                            <h2>OBJETIVO</h2>
                            <P>
                                Valorar las características del personal a fin de detectar a los trabajadores que se distinguen en el desempeño de sus funciones y considerar los beneficios que se les puedan brindar de acuerdo al programa de estímulos y recompensas.
                            </P>

                            <!--  -->
                            <h2>INSTRUCCIONES</h2>
                            <p>
                                La calificación se realizará con la mayor objetividad e imparcialidad posible, en la inteligencia de que su manejo será de carácter confidencial.
                            </p>
                            <!--  -->
                            <p>
                                Al reverso de esta hoja encontrará una serie de factores que intervienen en el Desempeño Laboral del personal y cada uno de ellos tiene diferentes conceptos que deberán ser calificados individualmente.
                            </p>
                            <!--  -->
                            <p>
                                Se deberá analizar cada concepto y marcar la calificación de éste con una "<span>&#10004</span>" en el cuadro respectivo. No marque más de una calificación por concepto o de lo contrario será anulada.
                            </p>
                            <!--  -->

                            <!--  -->
                            <h2>DATOS DEL EVALUADO</h2>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="datos_evaluado.nombre_completo" label="NOMBRE" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="datos_evaluado.puesto" label="PUESTO" required></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                            <v-col cols="12" md="12">
                                    <v-text-field disabled v-model="datos_evaluado.dependencia" label="DEPENDENCIA" required></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                            <v-col cols="12" md="12">
                                    <v-text-field disabled v-model="datos_evaluado.adscripcion" label="ADSCRIPCIÓN" required></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="datos_evaluado.rfc" label="RFC" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="datos_evaluado.nivel" label="NIVEL" required></v-text-field>
                                </v-col>
                            </v-row>
                            <!--  -->
                            <h2>DATOS DEL EVALUADOR</h2>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="dato_responsable_zona.nombre_responsable" label="NOMBRE" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="dato_responsable_zona.puesto_responsable" label="PUESTO" required></v-text-field>
                                </v-col>
                            </v-row>
                            <!--  -->

                             <!--  -->
                             <h2>DATOS DE LA UNIDAD RESPONSABLE</h2>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="dato_cuatrimestre.nombre_completo" label="NOMBRE" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="dato_cuatrimestre.puesto_especifico" label="PUESTO" required></v-text-field>
                                </v-col>
                            </v-row>
                            <!--  -->
                            <br> <h3 class="text-center">CÉDULA DE EVALUACIÓN</h3><br>
                            <h3 class="text-center">{{ grupo_puesto_eval }}</h3><br>

                            <v-container v-for="item in datos_preguntas" :key="item.id">
                                <h3 class="text-center">{{ item.descripcion }}</h3><br>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th  style="width: 75%; text-align: left;"></th>
                                                <th v-for="item_valores in item.valores_evaluacion" :key="item_valores.id" style="width: 5%; text-align: left;">
                                                    {{ item_valores.descripcion }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item_preguntas in item.preguntas" :key="item_preguntas.id" >
                                            <td>{{ item_preguntas.descripcion }}</td>

                                            <td v-for="item_valores_preguntas in item_preguntas.valores_evaluacion" :key="item_valores_preguntas.id">
                                                <v-checkbox :disabled ='!editar' v-model="item_valores_preguntas.selected" @click="handleCheckboxChange(item_valores_preguntas, item_preguntas.valores_evaluacion)">
                                                </v-checkbox>
                                            </td>

                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-container>

                            <v-row justify="center" v-if="editar">
                                <v-col cols="12" md="auto" v-if="datos_preguntas.length >0">
                                    <v-btn color="primary" @click="guardar_formulario_empleado('enviar')">Enviar</v-btn>
                                </v-col>
                                <v-col cols="12" md="auto" v-if="datos_preguntas.length >0">
                                    <v-btn color="primary" @click="guardar_formulario_empleado('guardar')">Guardar</v-btn>
                                </v-col>
                            </v-row>
                            <v-row justify="center" v-else>
                                <v-col cols="12" md="auto">
                                    <v-alert type="success" icon="mdi-alert-circle-outline">
                                        Este formulario ha sido enviado!!!
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </div>
            </v-row>
            <!-- Incluye el componente ModalEspera -->
            <ModalEspera ref="modalEspera"/>
    </v-container>
    <v-container v-else>

            <v-row justify="center" v-if="!dato_cuatrimestre">
                <h3 class="text-center">NO SE HA ASIGNADO UN RESPONSABLE A ESTE USUARIO</h3><br> 
            </v-row>

            <v-row justify="center" v-if="!validacionZona">
                <h3 v-if="zonasNoAsignadas.length==0" class="text-center">NO SE PUEDE EVALUAR, YA QUE NO SE HAN ASIGNADO LOS RESPONSABLES A LAS ZONAS DE ADSCRIPCIÓN DE LA UNIDAD RESPONSABLE.</h3><br> 
                <h3 v-if="zonasNoAsignadas.length>0">LA(S) SIGUIENTE(S) ZONA(S) DE ADSCRIPCIÓN NO CUENTA(N) CON EMPLEADO(S) ASIGNADO(S), FAVOR DE VALIDAR CON EL ÁREA DE RECURSOS HUMANOS:</h3>
                <ul v-if="zonasNoAsignadas.length>0">
                    <li v-for="key in zonasNoAsignadas" >
                        {{ key }}
                    </li>
                </ul>
            </v-row>

    </v-container>


</template>
<style>
    .grupo-botones {
      display: none;
      margin-top: 10px;
    }

    .boton {
      padding: 10px 20px;
      margin-right: 5px;
    }

  </style>
<script>
import { mapState } from 'vuex'
import ModalEspera from "./ModalWait.vue";
export default {
    components: {
        ModalEspera,
    },
    data:function(){
        return {
            showTable:false,
            showAlert:false,
            tipos_filtro : [{id:0,descripcion:'TODOS'},{id:1,descripcion:'NO EVALUADOS'},{id:2,descripcion:'GUARDADOS'},{id:3,descripcion:'ENVIADOS'}],
            tipo_filtro : 0,
            // datos tabla
            columns: ["no_empleado",'adscripcion','nivel',"nombre","ap_paterno","ap_materno", 'estado_evaluacion','acciones'],
             options: {
                headings: {
                    no_empleado       : '# EMPLEADO',
                    adscripcion       : 'ZONA DE ADSCRIPCIÓN',
                    nivel             : 'NIVEL',
                    nombre            : "NOMBRE",
                    ap_paterno        : "APELLIDO PATERNO",
                    ap_materno        : "APELLIDO MATERNO",
                    estado_evaluacion : 'ESTADO DE EVALUACIÓN',
                    acciones          : 'ACCIONES',

                },
                sortable: ['no_empleado'],
                texts: {
                    count:"Mostrando de {from} a {to} de {count} resultados|{count} resultados|Un resultado",
                    filter:"Buscar:",
                    filterPlaceholder: 'Buscar...',
                    limit:"Resultados:",
                    recordsDisplay: 'Resultados',
                    page:"Página:",
                    noResults:"No hay resultados",
                    filterBy: 'Buscar...',
                    loading:'Cargando...',
                    defaultOption: 'Seleccionar {column}'
                },
                filterable: true,
                filterByColumn: false,
                resizableColumns: false,
                sendEmptyFilters :false,
                childRowTogglerFirst: true,
                showChildRowToggler: true,
                perPage: 5,
                perPageValues: [5, 10, 15, 20],
                filterable: ['no_empleado','adscripcion','nivel',"ap_paterno","ap_materno", "nombre"],
                    templates: {

                    }, filterByColumn: true,
            },
            mostrarModal: false,
            //variables
            empleados_a_evaluar    : [],
            liquidados             : [],
            mostrar_tabla_empleado : true,
            apellidoPaterno        : '',
            apellidoMaterno        : '',
            nombre                 : '',
            rfc                    : '',
            grupoPuesto            : '',
            datos_evaluador        : [],
            datos_evaluado         : [],
            datos_preguntas        : [],
            grupo_puesto_eval      : '',
            registro_evaluacion    : [],
            editar                 : true,
            dato_cuatrimestre      : false,
            zonas_adscripcion : [],
            id_zona_adscripcion : 0,
            informacion_evaluacion : [],
            dataFechaExtendida : false, 
            existeExcepcionPorcentajeZonaAds : false,
            validacionZona : false,
            dato_responsable_zona : {
                nombre_responsable: '',
                puesto_responsable: '',
            },
            zonasNoAsignadas : ''

        }
    },
    computed:{
        ...mapState(["user"]),
        ...mapState(["token"]),
        ...mapState(["baseUrl"])
    },
    async mounted(){
        this.datos_evaluador = JSON.parse(localStorage.getItem('user')); 
        await this.load_empleados_a_evaluar();
        await this.load_zonas_adscripcion();

        if(this.dato_cuatrimestre){
            await this.load_datos_cuatrimestre_evaluacion();
        }
        await this.validarAsignacionResponsablesZonaAdscripcion();
        this.$NProgress.done();
    },
    methods:{
        async load_empleados_a_evaluar(){
            
            try{
                 let response = await this.$http.get("get-empleados-cuatrimestre-a-evaluar/"+this.user.id_user+'/'+this.tipo_filtro+'/'+this.id_zona_adscripcion+'/'+this.user.tipo_evaluador);

                this.empleados_a_evaluar               = response.data.data.activos;
                this.dato_cuatrimestre                 = response.data.data.dato_cuatrimestre;
                this.dataFechaExtendida                = response.data.data.existeExtensionDeFecha
                this.existeExcepcionPorcentajeZonaAds = response.data.data.existeExcepcionZonaAdscripcion

                if(this.dato_cuatrimestre){
                    switch (this.dato_cuatrimestre.no_cuatrimestre) {
                    case '1':
                        this.dato_cuatrimestre.no_cuatrimestre = 'ENERO-ABRIL';
                        break;
                    case '2':
                        this.dato_cuatrimestre.no_cuatrimestre = 'MAYO-AGOSTO';
                        break;
                    case '3':
                        this.dato_cuatrimestre.no_cuatrimestre = 'SEPTIEMBRE-DICIEMBRE';
                        break;
                    default:
                        break;
                    }

                    if (this.empleados_a_evaluar){
                        this.showTable = true;
                    }else{
                        this.showAlert = true
                    }
                }



            }catch(error){
                this.showAlert = true;
            }
        },

        async load_zonas_adscripcion(){
            try{
                if(!this.dato_cuatrimestre || !this.dato_cuatrimestre.id){
                    this.zonas_adscripcion = [];
                    return;
                }

                let response = await this.$http.get("get-zona-adscripcion-empleados-cuatrimestre-a-evaluar/"+this.user.id_user+'/'+this.dato_cuatrimestre.id+'/'+this.user.tipo_evaluador);

                this.zonas_adscripcion = response.data.data.activos;



            }catch(error){
                this.showAlert = true;
            }
        },
        cambiar_vista_formulario :function(empleado){
           
            this.obtener_responsable_zona_adscripcion(empleado.id_ur,empleado.id_zona_adscripcion)
            this.datos_evaluado = empleado;
            this.grupo_puesto_eval = 'GRUPO '+empleado.grupo_puesto
            this.obtener_formularios_empleado();
            setTimeout(() => {
                this.mostrar_tabla_empleado = false

            }, 1000); 
            
        },

        async obtener_responsable_zona_adscripcion(id_ur,id_zona_adscripcion){
            try{
                let response = await this.$http.get("obtener-responsable-zona-adscripcion?id_ur="+id_ur+'&id_zona_adscripcion='+id_zona_adscripcion+'&cuatrimestre_id='+this.dato_cuatrimestre.id+'&user_id='+this.user.id_user+'&tipo_evaluador='+this.user.tipo_evaluador);
                let datoResponsable = response.data && response.data.data ? response.data.data.dato_responsable : null;

                this.dato_responsable_zona = (datoResponsable && typeof datoResponsable === 'object')
                    ? datoResponsable
                    : { nombre_responsable: '', puesto_responsable: '' };
            }catch(error){
                this.dato_responsable_zona = { nombre_responsable: '', puesto_responsable: '' };
            }
        },

        funcion_regresar:function(){
            this.mostrar_tabla_empleado = true;
        },

        async obtener_formularios_empleado(){
            try{
                this.datos_preguntas = []
                this.registro_evaluacion = []
                this.editar = true;
                let response = await this.$http.get("get-formulario-cuatrimestre-empleado/"+this.datos_evaluado.grupo_puestos_id+'/'+this.datos_evaluado.id_empleado+'/'+this.datos_evaluado.cuatrimestre_id+'/'+this.user.id_user+'/'+this.user.tipo_evaluador);

                this.datos_preguntas = response.data.data.activos;
                this.registro_evaluacion = response.data.data.registro_evaluacion;

                if(this.registro_evaluacion){
                    if(this.registro_evaluacion.estados_evaluacion_id == 2){
                        this.editar =false;
                    }
                }


            }catch(error){

            }
        },

        handleCheckboxChange(item_valores,grupo_de_valores) {

            grupo_de_valores.forEach(objeto => {
                if (item_valores.id !== objeto.id) {
                    // Duplica el objeto para evitar compartir referencias
                    objeto.selected = false;
                }
            });
             return grupo_de_valores
        },

        guardar_formulario_empleado:async function(tipo_guardado){

            try{
                var mensaje = '¿Estas seguro de guardar la evaluación?'
                var mensaje_advertencia = ''
                var mensaje_form_cuatri = 'EL FORMULARIO SE HA GUARDADO EXITOSAMENTE!!'
                if(tipo_guardado =='enviar'){
                    mensaje_form_cuatri = 'EL FORMULARIO SE HA ENVIADO EXITOSAMENTE!!'
                    mensaje = '¿Estas seguro de enviar la evaluación?'
                    mensaje_advertencia = 'una vez enviado no se podra editar la evaluación'
                }
                this.$swal({
                    className: "text-center",
                    title: mensaje,
                    text: mensaje_advertencia,
                    icon: "warning",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    buttons:["Cancelar","Aceptar"],
                    }).then(async (value) => {
                        if(value){
                        this.$refs.modalEspera.mostrarModal = true;
                        let form = new FormData();
                        // form.append("tipo_nomina",this.tipoNomina);
                        form.append("tipo_guardado",tipo_guardado);
                        form.append("datos_evaluado",JSON.stringify(this.datos_evaluado));
                        form.append("datos_preguntas",JSON.stringify(this.datos_preguntas));
                        form.append("id_user",this.user.id_user);
                        form.append("nombre_completo",this.dato_cuatrimestre.nombre_completo);
                        form.append("puesto_especifico",this.dato_cuatrimestre.puesto_especifico);
                        form.append("tipo_evaluador",this.user.tipo_evaluador);


                        let response = await this.$http.post("guardar-formulario-cuatrimestre",form);
                        if(response.data.response){
                            this.$toasted.success(mensaje_form_cuatri);


                            this.$refs.modalEspera.mostrarModal = false;
                            await this.load_empleados_a_evaluar();
                            await this.load_datos_cuatrimestre_evaluacion();
                            this.funcion_regresar();

                        }else{
                            this.$refs.modalEspera.mostrarModal = false;
                            this.$swal({
                                title: response.data.error,
                                text: "",
                                icon: "error",
                                button:"Aceptar"
                            }).then(() => this.dialog = true);


                        }
                    }
                });
            }catch(error){
                this.$refs.modalEspera.mostrarModal = false;
                console.log(error)
            }
        },

        cambiar_a_guardado : function(empleado){
            try{
                var mensaje = '¿Estas seguro de cambiar el estatus a guardado?'
                var mensaje_advertencia = ''

                this.$swal({
                    className: "text-center",
                    title: mensaje,
                    text: mensaje_advertencia,
                    icon: "warning",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    buttons:["Cancelar","Aceptar"],
                    }).then(async (value) => {
                        if(value){
                        this.$refs.modalEspera.mostrarModal = true;
                        let form = new FormData();
                        // form.append("tipo_nomina",this.tipoNomina);
                        form.append("cuatrimestre_id",empleado.cuatrimestre_id);
                        form.append("id_empleado",empleado.id_empleado);
                        form.append("evaluador_id",this.user.id_empleado);

                        let response = await this.$http.post("actualizar-estado-empleado-formulario",form);
                        if(response.data.response){
                            this.$refs.modalEspera.mostrarModal = false;
                            await this.load_empleados_a_evaluar();
                            this.funcion_regresar();
                            this.$toasted.success('EL ESTATUS SE ACTUALIZO EXITOSAMENTE!!');

                        }else{
                            this.$refs.modalEspera.mostrarModal = false;
                            this.$swal({
                                title: response.data.error,
                                text: "",
                                icon: "error",
                                button:"Aceptar"
                            }).then(() => this.dialog = true);


                        }
                    }
                });
            }catch(error){
                this.$refs.modalEspera.mostrarModal = false;
                console.log(error)
            }
        },
        async load_datos_cuatrimestre_evaluacion(){
            try{
                let response = await this.$http.get("obtener-datos-generales-evaluacion/"+this.user.id_user+'/'+this.dato_cuatrimestre.id+'/'+this.id_zona_adscripcion+'/'+this.user.tipo_evaluador);

                this.informacion_evaluacion = response.data.data;

            }catch(error){
                this.showAlert = true;
            }
        },

        descargarAcuse: function(datos){
            const form = document.createElement('form');
            form.target = "_blank";
            form.method = 'post';
            form.id = 'form';
            form.action = `${this.baseUrl}download-acuse-evaluacion-cuatrimestre?token=${this.token}`;

            const registro_evaluacion_id = document.createElement('input')
            registro_evaluacion_id.type = 'hide';
            registro_evaluacion_id.name = 'registro_evaluacion_id';
            registro_evaluacion_id.value = datos.registro_evaluacion_id;
            form.append(registro_evaluacion_id);

            const grupo_puestos_id = document.createElement('input')
            grupo_puestos_id.type = 'hide';
            grupo_puestos_id.name = 'grupo_puestos_id';
            grupo_puestos_id.value = datos.grupo_puestos_id;
            form.append(grupo_puestos_id);

            const id_cuatrimestre = document.createElement('input')
            id_cuatrimestre.type = 'hide';
            id_cuatrimestre.name = 'id_cuatrimestre';
            id_cuatrimestre.value = datos.cuatrimestre_id;
            form.append(id_cuatrimestre);

            const id_ur = document.createElement('input')
            id_ur.type = 'hide';
            id_ur.name = 'id_ur';
            id_ur.value = datos.id_ur;
            form.append(id_ur);

            const id_zona_adscripcion = document.createElement('input')
            id_zona_adscripcion.type = 'hide';
            id_zona_adscripcion.name = 'id_zona_adscripcion';
            id_zona_adscripcion.value = datos.id_zona_adscripcion;
            form.append(id_zona_adscripcion);

            const user_id = document.createElement('input')
            user_id.type = 'hide';
            user_id.name = 'user_id';
            user_id.value = this.user.id_user;
            form.append(user_id);

            const tipo_evaluador = document.createElement('input')
            tipo_evaluador.type = 'hide';
            tipo_evaluador.name = 'tipo_evaluador';
            tipo_evaluador.value = this.user.tipo_evaluador;
            form.append(tipo_evaluador);


            document.querySelector('body').append(form);
            //-----------------------------------------------------------------------------------------------------
            form.submit();
            document.querySelector('body').removeChild(document.getElementById('form'))
        },

        async validarAsignacionResponsablesZonaAdscripcion(){
            try{ 
                let response = await this.$http.get("validar-asignacion-total-responsables-zona-adscripcion?user_id="+this.user.id_user+'&cuatrimestre_id='+this.dato_cuatrimestre.id+'&tipo_evaluador='+this.user.tipo_evaluador); 
                this.validacionZona = response.data.data.validacionZona; 
                this.zonasNoAsignadas = response.data.data.adscripcionesSinEmpleados;
            }catch(error){
                
            }
        },
    }
}
</script>
